import type { AppliedLabel } from '@evogard/contract';
import {
  LabelTags,
  LabelsPicker,
  type LabelOptions,
  type SaveLabels,
} from '../../../components/labels/LabelsPicker.js';
import { useLabelOptions, useLabelPermissions, useSetClaimLabels } from './useLabels.js';

export type { LabelOptions, SaveLabels };

/**
 * As etiquetas que o card tem, como selos de cor — no cartão do quadro, na
 * tabela e na mesa. O desenho mora em `components/labels/` desde 27/10/2026,
 * quando a mesa da despesa do Financeiro passou a usar o mesmo.
 */
export const ClaimLabelTags = LabelTags;

/**
 * As etiquetas da mesa (07/10/2026): os selos no alto do miolo, acima das
 * abas — no cabeçalho até 08/10/2026, quando muitas etiquetas empurravam as
 * pastilhas do analista e do vencimento —, e a pastilha tracejada de etiqueta
 * ao lado deles abre a lista dos setores de quem usa, de escolha múltipla.
 */
export function ClaimLabelsHeader({
  claimId,
  labels,
  enabled,
}: {
  claimId: number;
  labels: readonly AppliedLabel[];
  /** Falso no sinistro arquivado: só os selos. */
  enabled: boolean;
}) {
  const save = useSetClaimLabels(claimId);
  const options = useLabelOptions();
  return <LabelsHeader labels={labels} enabled={enabled} save={save} options={options} />;
}

/**
 * Os selos e o seletor do sinistro e do acionamento de Periféricos
 * (15/10/2026), com a permissão do sinistro: pôr e tirar é
 * `claims.labels:aplicar`.
 */
export function LabelsHeader({
  labels,
  enabled,
  save,
  options,
}: {
  labels: readonly AppliedLabel[];
  /** Falso no card arquivado: só os selos. */
  enabled: boolean;
  save: SaveLabels;
  /** As etiquetas dos setores de quem usa — pela rota do card, que tem a permissão dele. */
  options: LabelOptions;
}) {
  const { canApply } = useLabelPermissions();
  return (
    <LabelsPicker
      labels={labels}
      editable={enabled && canApply}
      save={save}
      options={options}
    />
  );
}
